import React from 'react';
import { 
  TrendingUp, 
  Calendar, 
  Award, 
  Globe2,
  CheckCircle2,
  Brain,
  HeartPulse,
  Activity,
  Microscope,
  Users
} from 'lucide-react';
import './Asc46.css';

const Asc46: React.FC = () => {
  return (
    <div className="asc46">
      {/* Hero Section */}
      <div className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>BNCT Success Stories</h1>
          <p>Pioneering Cancer Treatment in Taiwan</p>
        </div>
      </div>

      {/* Treatment Progress */}
      <section className="progress-section container">
        <h2 className="section-title">Treatment Evolution</h2>
        <div className="timeline">
          <div className="timeline-item">
            <div className="timeline-date">
              <Calendar className="date-icon" />
              <span>Before 2010</span>
            </div>
            <div className="timeline-content">
              <h3>Initial Research Phase</h3>
              <p>4 successful treatment cases completed by TVGH and NTHU research team</p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-date">
              <Calendar className="date-icon" />
              <span>2017-2021</span>
            </div>
            <div className="timeline-content">
              <h3>Emergency Medical Option</h3>
              <p>188 emergency medical cases treated, with 80% at Taipei Veterans General Hospital</p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-date">
              <Calendar className="date-icon" />
              <span>June 2022</span>
            </div>
            <div className="timeline-content">
              <h3>Expanded Treatment</h3>
              <p>285 patients treated for recurrent head and neck cancer and malignant brain tumors</p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-date">
              <Calendar className="date-icon" />
              <span>November 2023</span>
            </div>
            <div className="timeline-content">
              <h3>Clinical Milestone</h3>
              <p>Over 300 compassionate-use cases completed and clinical trial enrollment initiated</p>
            </div>
          </div>
        </div>
      </section>

      {/* International Recognition */}
      <section className="recognition-section">
        <div className="container">
          <h2 className="section-title">Global Impact</h2>
          <div className="video-container">
            <iframe
              src="https://www.youtube.com/embed/ffLqohEXzaE"
              title="International Patient Success Story"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <div className="achievements-grid">
            <div className="achievement-card">
              <Globe2 className="achievement-icon" />
              <h3>International Reach</h3>
              <p>20 successful cases with international patients</p>
            </div>
            <div className="achievement-card">
              <Award className="achievement-icon" />
              <h3>Medical Innovation</h3>
              <p>First country to officially incorporate BNCT into clinical treatment</p>
            </div>
            <div className="achievement-card">
              <Users className="achievement-icon" />
              <h3>Expert Team</h3>
              <p>Cross-institutional and interdisciplinary medical team</p>
            </div>
          </div>
        </div>
      </section>

      {/* Treatment Success Cases */}
      <section className="cases-section container">
        <h2 className="section-title">Treatment Success by Cancer Type</h2>
        <div className="cases-grid">
          <div className="case-card">
            <HeartPulse className="case-icon" />
            <h3>Head and Neck Cancer</h3>
            <div className="case-stats">
              <TrendingUp className="stats-icon" />
              <p>47% 2-year survival rate in Phase I/II trial</p>
            </div>
            <ul className="case-details">
              <li>17 patients treated (2010-2015)</li>
              <li>Locally recurrent cases</li>
              <li>Promising efficacy demonstrated</li>
            </ul>
          </div>

          <div className="case-card">
            <Brain className="case-icon" />
            <h3>Malignant Brain Tumors</h3>
            <div className="case-stats">
              <TrendingUp className="stats-icon" />
              <p>Up to 17.66 months survival for complete response</p>
            </div>
            <ul className="case-details">
              <li>34 end-stage patients treated</li>
              <li>7.25 months mean survival</li>
              <li>No severe adverse events</li>
            </ul>
          </div>

          <div className="case-card">
            <Microscope className="case-icon" />
            <h3>Recurrent Meningioma</h3>
            <div className="case-stats">
              <CheckCircle2 className="stats-icon" />
              <p>Successful treatment in all cases</p>
            </div>
            <ul className="case-details">
              <li>4 cases treated</li>
              <li>5 treatment courses</li>
              <li>Alternative for limited options</li>
            </ul>
          </div>

          <div className="case-card">
            <Activity className="case-icon" />
            <h3>Liver Cancer</h3>
            <div className="case-stats">
              <TrendingUp className="stats-icon" />
              <p>First human trials planned for 2024</p>
            </div>
            <ul className="case-details">
              <li>Collaboration with MacKay Memorial Hospital</li>
              <li>Focus on diffuse tumors</li>
              <li>Treatment for recurring cases</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Asc46;